import {
    ParticipantMatchListActions,
    ParticipantMatchListSetFilterDataAction,
    ParticipantMatchListSetLoadingData,
    ParticipantMatchListStoreModel,
    ParticipantMatchListTopic,
} from './participant-match-list.constants';
import { AppDispatch, GetState } from '@om-fe/core/core/types';
import {
    apiSubscribeAction,
    apiUnsubscribeAction,
    attachReducerAction,
    detachReducerAction,
} from '@om-fe/core/utils/action';
import { getParticipantMatchListSliceName, getParticipantMatchListTopic } from './participant-match-list.utils';
import { participantMatchListReducerCreator } from './participant-match-list.reducer';
import { filterNullParams } from '@om-fe/core/utils/router';
import getSlice from '@om-fe/core/utils/get-slice';
import { DisciplineLiveStatus } from '@om-fe/models';

export const participantMatchListSetLoadingData = (slice: string, isLoadingMoreData: boolean = false): ParticipantMatchListSetLoadingData => ({
    type: ParticipantMatchListActions.SetLoadingData,
    meta: {
        slice,
    },
    payload: {
        isLoadingMoreData,
    },
});

export const participantMatchListSetFilterData = (
    slice: string,
    participantId: string,
    liveStatus: DisciplineLiveStatus,
): ParticipantMatchListSetFilterDataAction => ({
    type: ParticipantMatchListActions.SetFilterData,
    meta: {
        slice,
    },
    payload: {
        participantId,
        liveStatus,
    },
});

export const getParticipantMatchList = (
    instanceId: string,
    participantId: string,
    liveStatus: DisciplineLiveStatus,
    mainMarketsLimit: number | undefined,
) => (dispatch: AppDispatch) => {
    const slice: string = getParticipantMatchListSliceName(instanceId);

    const topic: ParticipantMatchListTopic = getParticipantMatchListTopic(
        participantId,
        liveStatus,
        mainMarketsLimit,
    );

    dispatch(attachReducerAction(slice, participantMatchListReducerCreator(instanceId)));

    dispatch(participantMatchListSetFilterData(
        slice,
        participantId,
        liveStatus,
    ));

    dispatch(apiSubscribeAction(topic.path, filterNullParams(topic.params), slice));
};

export const removeParticipantMatchList = (
    instanceId: string,
) => (dispatch: AppDispatch, getState: GetState) => {
    const slice: string = getParticipantMatchListSliceName(instanceId);

    const matchListState: ParticipantMatchListStoreModel | undefined = getSlice<ParticipantMatchListStoreModel>(getState(), slice);

    if (!matchListState) {
        return;
    }

    const topic: ParticipantMatchListTopic = getParticipantMatchListTopic(
        matchListState.participantId!,
        matchListState.liveStatus,
        matchListState.mainMarketsLimit,
    );

    dispatch(detachReducerAction(slice));
    dispatch(apiUnsubscribeAction(topic.path, filterNullParams(topic.params), slice));
};

export const updateParticipantMatchList = (
    instanceId: string,
    participantId: string,
    liveStatus: DisciplineLiveStatus,
    mainMarketsLimit: number | undefined,
) => (dispatch: AppDispatch, getState: GetState): void => {
    const slice: string = getParticipantMatchListSliceName(instanceId);

    const matchListState: ParticipantMatchListStoreModel | undefined = getSlice<ParticipantMatchListStoreModel>(getState(), slice);

    if (!matchListState) {
        return;
    }

    const oldTopic: ParticipantMatchListTopic = getParticipantMatchListTopic(
        matchListState.participantId!,
        matchListState.liveStatus,
        matchListState.mainMarketsLimit,
    );

    const newTopic: ParticipantMatchListTopic = getParticipantMatchListTopic(
        participantId,
        liveStatus,
        mainMarketsLimit,
    );

    dispatch(participantMatchListSetLoadingData(slice, true));
    dispatch(participantMatchListSetFilterData(
        slice,
        participantId,
        liveStatus,
    ));

    dispatch(apiUnsubscribeAction(oldTopic.path, filterNullParams(oldTopic.params), slice));
    dispatch(apiSubscribeAction(newTopic.path, filterNullParams(newTopic.params), slice));
};
